const images = {
  jtac_virtual_trainer: require('./attack_lines.png'),
  bloom: require('./bloom.png'),
  doctor_eisenbarth__traveling_physician: require('./doctor_eisenbarth__traveling_physician.png'),
  brazen: require('./brazen_abelgas.jpeg'),
  icon_dark: require('./b_icon_darkmode.svg'),
  cozy_cafe: require('./cozy_cafe.png'),
};

export default images;
